namespace Matrix.Data {
    export interface BatchReviewRequest extends Serenity.ServiceRequest {
        RowIds?: number[];
    }
}
